<div class="palette-container" resizeObserver (resize)="onResize($event)">
    <div>
        @if (linqset && !linqset.isOrganisationModel() && !linqset.isTutorial()) {
            <button mat-button class="palette-menu-button" [matTooltip]="selectedTagGroup ? 'Showing tags from ' + selectedTagGroup.name : 'Show the tags from a tag group on actions'" aria-label="Choose a tag group to show" color="primary" [matMenuTriggerFor]="tagGroupMenu">
                <mat-icon>sell</mat-icon>
                <span class="button-label">{{selectedTagGroup?selectedTagGroup.name:'Tags'}}</span>
                <mat-icon iconPositionEnd fontIcon="keyboard_arrow_down"></mat-icon>
            </button>

            <mat-menu #tagGroupMenu="matMenu">
                @if (hasWriteAccess()) {
                    <button mat-menu-item (click)="createTagGroup()">
                        <mat-icon>add</mat-icon>
                        Create tag group
                    </button>
                    <mat-divider></mat-divider>
                }
                @for (tg of tagGroups; track tg._key) {
                    <button mat-menu-item (click)="selectTagGroup(tg)">
                        <mat-icon>{{selectedTagGroup?._key === tg._key ? 'check' : ''}}</mat-icon>
                        <span>{{tg.name}}</span>
                    </button>
                }@empty {
                    <button mat-menu-item disabled>No tag groups for this model</button>
                }
                @if (selectedTagGroup) {
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="selectTagGroup(undefined)">
                        <mat-icon>visibility_off</mat-icon>
                        <span>Hide tags</span>
                    </button>
                }
            </mat-menu>
        }
    </div>

    <div class="node-palette">
        <app-node-palette [isOrganisationModel]="linqset && linqset.isOrganisationModel()" [smallScreen]="smallScreen"></app-node-palette>
    </div>

    <div>
        @if (groups.length>0 && linqset && !linqset.isOrganisationModel() && !linqset.isTutorial()) {
            <button mat-button class="palette-menu-button" matTooltip="Add an output from another model, to join this model to it" aria-label="Add an output from another model" color="primary" [matMenuTriggerFor]="groupsMenu">
                <mat-icon>link</mat-icon>
                <span class="button-label">Join</span>
                <mat-icon iconPositionEnd fontIcon="keyboard_arrow_down"></mat-icon>
            </button>
            <mat-menu #groupsMenu="matMenu">
                @for (group of groups; track group._key) {
                <ng-container>
                    <button mat-menu-item [matMenuTriggerFor]="sub_menu">{{ group.name }}</button>
                    <mat-menu #sub_menu="matMenu">
                    @for (node of group.nodes; track node._key) {
                        <button mat-menu-item (click)="externalNodeSelected(node)">
                            <span class="image-text">
                                <app-node-svg [type]="node.type" [caller]="'Palette'"/>
                                <span>{{node.name || "Missing node name"}}</span>
                            </span>
                        </button>
                    }
                    </mat-menu>
                </ng-container>
                }
            </mat-menu>
        }
    </div>
</div>
